import { createWatcher, WatcherType } from 'rewire-core';
import { IRowData, IGrid }            from 'rewire-grid';

export default class SelectedRowWatcher {
  _watch:          WatcherType<IGrid>;
  lastSelectedRow: IRowData;

  constructor() {
    this._watch = createWatcher();
  }

  watch(grid: IGrid, callback: (row?: any, foundRow?: any) => void) {
    const myCallback = () => {
      const row = grid.selectedRows[0];
      if (row === this.lastSelectedRow) return;
      this.lastSelectedRow = row;

      if (row?.id) {
        const foundRow = grid.rows.find(r => r.id === row.id);
        callback(foundRow?.data || foundRow, foundRow);
      } else {
        callback(undefined);
      }
    };
    this._watch(grid, ['selectedRows'], myCallback);
  }

  unwatch() {
    this._watch();
  }
}
